/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetCostTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("BudgetCostTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return BudgetCostTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BudgetCostTrendWidgetConfiguration>): BudgetCostTrendWidgetConfiguration {
        let obj = Object.assign(new BudgetCostTrendWidgetConfiguration(), model);
        BudgetCostTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetCostTrendWidgetConfiguration>): BudgetCostTrendWidgetConfiguration {
        if (!model) return null;
        return BudgetCostTrendWidgetConfiguration.newInstance(<BudgetCostTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetCostTrendWidgetConfiguration) {
        if (!obj) return;

        models.BudgetCostTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetCostTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BudgetCostTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the currently selected budget — persisted to restore the dropdown selection on reload
     */
    selectedBudgetId: string;

}
